<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-8 col-md-7 col-7 d-flex align-items-center">
        <h4
          class="col-lg-10 col-md-10 col-12 text-back d-flex align-items-center ps-2 cursor-pointer"
          @click="backPromoCodeList()"
        >
          <i class="fa fa-chevron-circle-left pe-2" aria-hidden="true"></i>
          <div>BACK</div>
        </h4>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <div class="container" v-if="isLoadDoneData">
        <div class="card-custom-new promo-card">
          <div class="promo-head">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <h3 class="title-page mb-0">
                {{ promo_code.id ? "EDIT PROMO CODE" : "CREATE PROMO CODE" }}
              </h3>
              <span class="promo-id">PC{{ promo_code.id ?? promoCodeIdDummy }}</span>
            </div>
            <!-- What the promo does, in one line, as the form stands now. -->
            <div class="promo-summary">{{ summary }}</div>
          </div>

          <section class="promo-section">
            <h6 class="promo-section__title">Basics</h6>
            <div class="promo-row">
              <label class="promo-label" for="promo_name">Name <span class="text-danger">*</span></label>
              <div class="promo-field">
                <material-input
                  id="promo_name"
                  v-model="promo_code.promo_name"
                  name="promo_name"
                  maxLength="100"
                  placeholder="Enter promo name"
                />
                <span class="is-invalid" v-if="errors.promo_name">{{ errors.promo_name }}</span>
              </div>
            </div>
            <div class="promo-row">
              <div class="promo-label">Type</div>
              <div class="promo-field">
                <!-- Generic and unique keep their codes in different places: fixed once created. -->
                <div class="radio-inline">
                  <MaterialRadio
                    v-model="promo_code.promo_type"
                    id="generic_promo_code"
                    name="promo_type"
                    value="1"
                    :disabled="!!promo_code.id"
                  >
                    Generic (one code for everyone)
                  </MaterialRadio>
                  <MaterialRadio
                    v-model="promo_code.promo_type"
                    id="unique_promo_code"
                    name="promo_type"
                    value="2"
                    :disabled="!!promo_code.id"
                  >
                    Unique (single-use codes)
                  </MaterialRadio>
                </div>
                <div v-if="promo_code.id" class="promo-hint">The type cannot be changed after the promo code is created.</div>
              </div>
            </div>
            <div class="promo-row" v-if="promo_code.promo_type == 1">
              <label class="promo-label" for="promo_code">Code <span class="text-danger">*</span></label>
              <div class="promo-field promo-field--narrow">
                <material-input
                  type="text"
                  v-model="promo_code.promo_code"
                  id="promo_code"
                  name="promo_code"
                  maxLength="50"
                  placeholder="Code customers type, e.g. LUNCH10"
                />
                <span class="is-invalid" v-if="errors.promo_code">{{ errors.promo_code }}</span>
              </div>
            </div>
            <div class="promo-row">
              <div class="promo-label">Status</div>
              <div class="promo-field">
                <div class="radio-inline">
                  <MaterialRadio v-model="promo_code.status" id="active" name="status" value="1">Active</MaterialRadio>
                  <MaterialRadio v-model="promo_code.status" id="deactive" name="status" value="0">Inactive</MaterialRadio>
                </div>
                <div v-if="promo_code.status != 1" class="promo-hint">Customers cannot use the code until it is Active.</div>
              </div>
            </div>
          </section>

          <section class="promo-section">
            <h6 class="promo-section__title">Discount</h6>
            <div class="promo-row">
              <div class="promo-label">Discount <span class="text-danger">*</span></div>
              <div class="promo-field">
                <div class="radio-inline">
                  <MaterialRadio v-model="promo_code.discount_type" id="percentage_off" name="discount_type" value="1">
                    Percentage Off
                  </MaterialRadio>
                  <MaterialRadio v-model="promo_code.discount_type" id="fixed_amount_off" name="discount_type" value="2">
                    Fixed Amount Off
                  </MaterialRadio>
                </div>
                <!-- Only the value of the chosen type is saved (discount_value). -->
                <div class="d-flex align-items-center promo-value">
                  <span v-if="promo_code.discount_type != 1" class="promo-affix">$</span>
                  <material-input
                    v-if="promo_code.discount_type == 1"
                    type="number"
                    v-model="promo_code.discount_value_percentage"
                    id="discount_value_percentage"
                    name="discount_value_percentage"
                    placeholder="1 - 100"
                  />
                  <material-input
                    v-else
                    type="number"
                    v-model="promo_code.discount_value_fixed_amount"
                    id="discount_value_fixed_amount"
                    name="discount_value_fixed_amount"
                    placeholder="Amount off"
                  />
                  <span v-if="promo_code.discount_type == 1" class="promo-affix">%</span>
                </div>
                <span class="is-invalid" v-if="errors.discount">{{ errors.discount }}</span>
              </div>
            </div>
            <div class="promo-row">
              <div class="promo-label">Apply To</div>
              <div class="promo-field">
                <div class="radio-inline">
                  <MaterialRadio v-model="promo_code.apply_scope" id="apply_scope_bill" name="apply_scope" value="1">
                    Whole Bill
                  </MaterialRadio>
                  <MaterialRadio
                    v-model="promo_code.apply_scope"
                    id="apply_scope_report_group"
                    name="apply_scope"
                    value="2"
                  >
                    Items in Report Groups
                  </MaterialRadio>
                </div>
                <template v-if="promo_code.apply_scope == 2">
                  <Multiselect
                    v-model="promo_code.report_group_ids"
                    mode="tags"
                    :close-on-select="false"
                    :searchable="true"
                    :options="reportGroups"
                    placeholder="Select report groups"
                    noOptionsText="No report groups yet"
                    class="mt-2"
                  />
                  <span class="is-invalid" v-if="errors.report_group_ids">{{ errors.report_group_ids }}</span>
                  <div class="radio-inline mt-2">
                    <MaterialRadio
                      v-model="promo_code.include_modifiers"
                      id="include_modifiers_no"
                      name="include_modifiers"
                      value="0"
                    >
                      Main items only
                    </MaterialRadio>
                    <MaterialRadio
                      v-model="promo_code.include_modifiers"
                      id="include_modifiers_yes"
                      name="include_modifiers"
                      value="1"
                    >
                      Main items + modifiers
                    </MaterialRadio>
                  </div>
                </template>
              </div>
            </div>
          </section>

          <section class="promo-section">
            <h6 class="promo-section__title">Where &amp; when</h6>
            <div class="promo-row">
              <div class="promo-label">Branches</div>
              <div class="promo-field">
                <Multiselect
                  v-model="promo_code.apply_for_store"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="true"
                  :options="branches"
                  placeholder="Select branches to apply"
                  :canClear="false"
                />
              </div>
            </div>
            <div class="promo-row">
              <div class="promo-label">Expiry <span class="text-danger">*</span></div>
              <div class="promo-field">
                <div class="radio-inline">
                  <MaterialRadio v-model="expiryMode" id="expiry_mode_date" name="expiry_mode" value="date">
                    On a fixed date
                  </MaterialRadio>
                  <!-- A period only makes sense per issued code; an older generic promo set this way keeps it. -->
                  <MaterialRadio
                    v-if="promo_code.promo_type == 2 || expiryMode === 'after'"
                    v-model="expiryMode"
                    id="expiry_mode_after"
                    name="expiry_mode"
                    value="after"
                  >
                    After a period from issue
                  </MaterialRadio>
                </div>
                <div v-if="expiryMode === 'date'" class="promo-value">
                  <Datepicker
                    v-model="promo_code.expiry_date"
                    :enableTimePicker="false"
                    class="date-time"
                    :format="format"
                    placeholder="Select expiry date"
                  />
                  <div class="promo-hint">The code works until the end of this day.</div>
                </div>
                <div v-else class="d-flex align-items-center gap-2 promo-period">
                  <material-input
                    id="time_number"
                    type="number"
                    v-model="promo_code.time_number"
                    name="time_number"
                    placeholder="Number"
                    class="promo-period__number"
                  />
                  <Multiselect
                    v-model="promo_code.time_unit"
                    :options="timeUnits"
                    placeholder="Unit"
                    :canClear="false"
                    class="promo-period__unit"
                  />
                  <span class="text-sm text-nowrap">after issue</span>
                </div>
                <span class="is-invalid" v-if="errors.expiry">{{ errors.expiry }}</span>
              </div>
            </div>
            <!-- Shown once the API returns schedules (tenant migrated); usable once the promo is saved. -->
            <div class="promo-row" v-if="schedulesAvailable">
              <div class="promo-label">Usage Schedule</div>
              <div class="promo-field">
                <!-- Same look as the Special Scheduled Price button (StoreDetail). -->
                <button
                  type="button"
                  class="btn btn-sm capitalize btn-background mb-0 promo-schedule-btn"
                  :disabled="!promo_code.id"
                  :title="promo_code.id ? 'Set the times this code can be used' : 'Save the promo code first'"
                  @click="$refs.schedulesModal.open(schedules, schedulesEnabled)"
                >
                  <i class="material-icons promo-schedule-btn__icon">schedule</i>
                  Schedule
                  <span
                    class="promo-schedule-btn__state"
                    :class="{
                      'promo-schedule-btn__state--on': schedulesEnabled == 1 && !schedulesEnded,
                      'promo-schedule-btn__state--ended': schedulesEnded,
                    }"
                    >{{ schedulesSummary }}</span
                  >
                </button>
                <div v-if="!promo_code.id" class="promo-hint">Save the promo code first to set a schedule.</div>
                <div v-else-if="schedulesEnded" class="promo-hint text-warning">
                  All schedules have ended, so this code can no longer be used. Add a new schedule or turn the
                  schedule off.
                </div>
              </div>
            </div>
          </section>

          <section class="promo-section">
            <h6 class="promo-section__title">Limits</h6>
            <div class="promo-row">
              <label class="promo-label" for="total_quantity">Issue Quantity <span class="text-danger">*</span></label>
              <div class="promo-field promo-field--narrow">
                <material-input
                  id="total_quantity"
                  type="number"
                  v-model="promo_code.total_quantity"
                  name="total_quantity"
                  :placeholder="promo_code.promo_type == 2 ? 'Number of codes' : 'Total uses'"
                />
                <span class="is-invalid" v-if="errors.total_quantity">{{ errors.total_quantity }}</span>
                <div class="promo-hint">
                  {{ promo_code.promo_type == 2 ? "Number of unique codes." : "How many orders can use the code in total." }}
                  <template v-if="minQuantity.value > 1 && !errors.total_quantity">
                    Cannot be lower than {{ minQuantity.value }} ({{ minQuantity.reason }}).
                  </template>
                </div>
                <div v-if="promo_code.id" class="promo-usage">
                  <div class="promo-usage__bar">
                    <span :style="{ width: redeemedPercent + '%' }"></span>
                  </div>
                  Redeemed <strong>{{ promo_code.redeemed_quantity ?? 0 }}</strong> · Remaining
                  <strong>{{ remainingQuantity }}</strong>
                </div>
              </div>
            </div>
            <div class="promo-row">
              <label class="promo-label" for="daily_limit">Daily Limit</label>
              <div class="promo-field promo-field--narrow">
                <material-input
                  id="daily_limit"
                  type="number"
                  v-model="promo_code.daily_limit"
                  name="daily_limit"
                  placeholder="No limit"
                />
                <span class="is-invalid" v-if="errors.daily_limit">{{ errors.daily_limit }}</span>
                <div class="promo-hint">Max orders a day, all channels. Resets at midnight.</div>
                <span
                  v-if="promo_code.id && savedDailyLimit"
                  class="promo-today"
                  :class="{ 'promo-today--full': usedToday >= savedDailyLimit }"
                >
                  Today {{ usedToday }} / {{ savedDailyLimit }} ·
                  {{ usedToday >= savedDailyLimit ? "limit reached" : savedDailyLimit - usedToday + " left" }}
                </span>
              </div>
            </div>
          </section>

          <section class="promo-section">
            <h6 class="promo-section__title">Note</h6>
            <material-textarea v-model="promo_code.note" />
          </section>

          <!-- Stays at the bottom of the screen while the form scrolls. -->
          <div class="promo-actions">
            <span v-if="isDirty" class="promo-actions__dirty">Unsaved changes</span>
            <button type="button" class="btn btn-outline-secondary mb-0" @click="backPromoCodeList()">Cancel</button>
            <material-button
              @click="savePromoCode()"
              :disabled="saving"
              class="mb-0 btn-background save-btn"
              :style="`background: ${this.$store.state.buttonColor} !important`"
            >
              {{ saving ? "Saving..." : promo_code.id ? "Save" : "Create" }}
            </material-button>
          </div>
        </div>

        <!-- Unique codes only: a generic promo has no codes of its own to list. -->
        <div class="card-custom-new promo-card mt-4" v-if="promo_code.id && promo_code.promo_type == 2">
          <div class="d-flex align-items-center flex-wrap gap-2 mb-3">
            <h5 class="mb-0 me-2 promo-codes-title">Unique Codes</h5>
            <span class="promo-chip">Total {{ promo_code.total_distributed ?? 0 }}</span>
            <span class="promo-chip">Sent {{ promo_code.total_sent ?? 0 }}</span>
            <span class="promo-chip promo-chip--used">Used {{ promo_code.total_used ?? 0 }}</span>
            <span class="promo-chip promo-chip--expired">Expired {{ promo_code.total_expired ?? 0 }}</span>
          </div>
          <div class="row mb-2">
            <div class="col-md-6 col-12">
              <input
                class="nosubmit"
                type="search"
                v-model="codeSearch"
                placeholder="Search code"
                @input="onCodeSearch"
              />
            </div>
            <div class="col-md-3 col-6 ms-auto">
              <Multiselect
                v-model="codeStatus"
                :options="codeStatusOptions"
                :canClear="false"
                @change="onCodeStatus"
              />
            </div>
          </div>
          <div class="table-responsive p-0 custom-table">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-center font-weight-bolder">Code</th>
                  <th v-if="showSentTo" class="text-center font-weight-bolder">Sent To</th>
                  <th class="text-center font-weight-bolder">Created</th>
                  <th class="text-center font-weight-bolder">Expiry Date</th>
                  <th class="text-center font-weight-bolder">Redeemed Date</th>
                  <th class="text-center font-weight-bolder">Receipt</th>
                  <th class="text-center font-weight-bolder">Status</th>
                </tr>
              </thead>
              <tbody v-if="promo_code_data.length">
                <tr v-for="(value, key) in promo_code_data" :key="key">
                  <td class="text-center promo-code-cell">{{ value.code }}</td>
                  <td v-if="showSentTo" class="text-center">{{ value.member_phone || value.member_email || "—" }}</td>
                  <td class="text-center">{{ value.created_date_format }}</td>
                  <td class="text-center">{{ value.expiry_date_format }}</td>
                  <td class="text-center">{{ value.used_date_format }}</td>
                  <td class="text-center">{{ value.receipt_no }}</td>
                  <td class="text-center">
                    <span class="promo-chip" :class="'promo-chip--' + String(value.status_text).toLowerCase()">
                      {{ value.status_text }}
                    </span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td :colspan="showSentTo ? 7 : 6" class="text-center">No codes found</td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination
            v-if="pagination.last_page > 1"
            :pagination="pagination"
            :current_page="pagination.current_page"
            :last_page="pagination.last_page"
          />
        </div>
      </div>
      <ModalPromoCodeSchedules
        ref="schedulesModal"
        :promo-code-id="promo_code.id"
        @saved="onSchedulesSaved"
      />
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import MaterialButton from "@/components/MaterialButton.vue";
import SettingPromoCodeService from "../../services/settingPromoCode.service";
import ModalPromoCodeSchedules from "@/components/ModalPromoCodeSchedules.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialRadio from "@/components/MaterialRadio.vue";
import MaterialTextarea from "@/components/MaterialTextarea.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import CommonFunctionService from "../../services/commonFunction.service";
import moment from "moment";
import Pagination from "@/components/Pagination.vue";
import { scrollToFirstInvalid } from "@/config/utils";

// Whole number >= 1, or null for anything else.
const positiveInt = (value) => {
  const number = Number(value);
  return value !== "" && value !== null && Number.isInteger(number) && number >= 1 ? number : null;
};

// The fields the merchant edits: what "Unsaved changes" compares.
const EDITABLE = [
  "promo_name", "promo_code", "promo_type", "discount_type", "discount_value_percentage",
  "discount_value_fixed_amount", "apply_for_store", "apply_scope", "report_group_ids", "include_modifiers",
  "expiry_date", "fixed_date", "expiry_after", "time_number", "time_unit", "total_quantity", "daily_limit",
  "note", "status",
];

export default {
  name: "PromoCodeDetail",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    ModalPromoCodeSchedules,
    MaterialInput,
    MaterialRadio,
    Multiselect,
    Datepicker,
    MaterialTextarea,
    Pagination,
  },
  beforeRouteLeave(to, from, next) {
    next(this.confirmLeave());
  },
  beforeRouteUpdate(to, from, next) {
    next(this.confirmLeave());
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      saving: false,
      // One message per field, shown under it (same rules as PromoCodeDetailRequest).
      errors: {},
      promo_code: {
        id: null,
        promo_name: "",
        promo_code: "",
        promo_type: 1,
        discount_type: 1,
        discount_value_percentage: "",
        discount_value_fixed_amount: "",
        apply_for_store: [],
        apply_scope: 1,
        report_group_ids: [],
        include_modifiers: 0,
        expiry_date: null,
        fixed_date: 1,
        expiry_after: 0,
        time_number: "",
        time_unit: 1,
        total_quantity: "",
        daily_limit: "",
        note: "",
        status: 0,
      },
      // The form as loaded or last saved, for "Unsaved changes".
      savedState: null,
      // The daily limit as saved, for "Today" (the field may be edited meanwhile).
      savedDailyLimit: null,
      // The issue as saved, for the redeemed bar.
      savedTotalQuantity: null,
      branches: [],
      reportGroups: [],
      promoCodeIdDummy: "",
      isLoadDoneData: false,
      timeUnits: [],
      promo_code_data: [],
      pagination: {},
      page: 1,
      codeSearch: "",
      codeSearchTimer: null,
      codeStatus: "",
      codeStatusOptions: [
        { value: "", label: "All statuses" },
        { value: 1, label: "Sent" },
        { value: 2, label: "Used" },
        { value: 3, label: "Expired" },
      ],
      // Usage schedule, saved on its own (save-schedules), never with the promo form.
      schedulesAvailable: false,
      schedulesEnabled: 0,
      schedules: [],
    };
  },
  computed: {
    // The API keeps two flags (fixed_date / expiry_after); the form offers one choice.
    expiryMode: {
      get() {
        return Number(this.promo_code.expiry_after) === 1 && Number(this.promo_code.fixed_date) !== 1 ? "after" : "date";
      },
      set(mode) {
        this.promo_code.fixed_date = mode === "date" ? 1 : 0;
        this.promo_code.expiry_after = mode === "after" ? 1 : 0;
      },
    },
    // As saved, not as being typed: the issue may be edited meanwhile.
    remainingQuantity() {
      return Math.max(0, Number(this.savedTotalQuantity || 0) - Number(this.promo_code.redeemed_quantity || 0));
    },
    // A saved promo's issue cannot go below what is already out (same rule as the API): its
    // redeemed uses, and for a unique promo the codes already generated (saving never deletes codes).
    minQuantity() {
      const redeemed = Number(this.promo_code.redeemed_quantity || 0);
      const issued = this.promo_code.id && this.promo_code.promo_type == 2 ? Number(this.promo_code.total_distributed || 0) : 0;
      if (issued > redeemed) {
        return { value: issued, reason: "unique codes already generated" };
      }
      return { value: Math.max(1, redeemed), reason: "already redeemed" };
    },
    redeemedPercent() {
      const total = Number(this.savedTotalQuantity || 0);
      return total > 0 ? Math.min(100, (Number(this.promo_code.redeemed_quantity || 0) / total) * 100) : 0;
    },
    usedToday() {
      return Number(this.promo_code.used_today ?? 0);
    },
    // Switch on, some schedules on, and every one of them is over: the code is blocked for good.
    schedulesEnded() {
      const active = this.schedules.filter((schedule) => schedule.status);
      return Number(this.schedulesEnabled) === 1 && active.length > 0 && active.every((schedule) => schedule.ended);
    },
    // Same text as the Special Scheduled Price button: "Off" / "On · 2 schedules".
    schedulesSummary() {
      if (Number(this.schedulesEnabled) !== 1) {
        return "Off";
      }
      if (this.schedulesEnded) {
        return "On · ended";
      }
      const active = this.schedules.filter((schedule) => schedule.status).length;
      return `On · ${active} schedule${active === 1 ? "" : "s"}`;
    },
    // "10% off whole bill · LUNCH10 · until 31/12/2026 · max 50/day · all branches"
    summary() {
      const promo = this.promo_code;
      const parts = [];

      const percentage = Number(promo.discount_value_percentage);
      const amount = Number(promo.discount_value_fixed_amount);
      let discount = "No discount yet";
      if (promo.discount_type == 1 && percentage > 0) {
        discount = `${percentage}% off`;
      } else if (promo.discount_type == 2 && amount > 0) {
        discount = `$${amount.toFixed(2)} off`;
      }
      if (promo.apply_scope == 2) {
        const groups = (promo.report_group_ids ?? []).length;
        discount += ` items in ${groups} report group${groups === 1 ? "" : "s"}`;
        discount += Number(promo.include_modifiers) === 1 ? " (with modifiers)" : "";
      } else {
        discount += " whole bill";
      }
      parts.push(discount);

      if (promo.promo_type == 1) {
        parts.push(String(promo.promo_code ?? "").trim() || "no code yet");
      } else {
        const total = positiveInt(promo.total_quantity);
        parts.push(total ? `${total} unique codes` : "unique codes");
      }

      if (this.expiryMode === "date") {
        parts.push(promo.expiry_date ? `until ${moment(promo.expiry_date).format("DD/MM/YYYY")}` : "no expiry date yet");
      } else if (positiveInt(promo.time_number)) {
        const unit = this.timeUnits.find((option) => option.value == promo.time_unit);
        parts.push(`each code lasts ${promo.time_number} ${unit ? unit.label : ""}`.trim());
      }

      const daily = positiveInt(promo.daily_limit);
      if (daily) {
        parts.push(`max ${daily}/day`);
      }

      const stores = promo.apply_for_store ?? [];
      if (stores.includes("all")) {
        parts.push("all branches");
      } else {
        parts.push(stores.length ? `${stores.length} branch${stores.length === 1 ? "" : "es"}` : "no branch");
      }

      if (promo.status != 1) {
        parts.push("Inactive");
      }

      return parts.join(" · ");
    },
    isDirty() {
      return this.savedState !== null && this.savedState !== this.formState();
    },
    // Hide the column when no code on this page was sent to anyone (bulk codes for anyone).
    showSentTo() {
      return this.promo_code_data.some((row) => row.member_phone || row.member_email);
    },
  },
  created() {
    this.getPromoCodeDetail();
  },
  mounted() {
    window.addEventListener("beforeunload", this.onBeforeUnload);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
  },
  watch: {
    // Create -> stays on the new promo's page: same component, new id.
    "$route.params.id"(id, oldId) {
      if (id && id !== oldId) {
        this.getPromoCodeDetail();
      }
    },
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    dateFormat(expiryDate) {
      return expiryDate == null ? null : moment(expiryDate).format("YYYY-MM-DD") + " 00:00:00";
    },

    formState() {
      const state = {};
      EDITABLE.forEach((field) => {
        const value = this.promo_code[field];
        state[field] = value === null || value === undefined ? "" : value;
      });
      if (state.expiry_date) {
        state.expiry_date = moment(state.expiry_date).format("YYYY-MM-DD");
      }

      return JSON.stringify(state, (key, value) => (typeof value === "number" ? String(value) : value));
    },

    markSaved() {
      this.savedState = this.formState();
    },

    // true = go ahead (nothing unsaved, or the merchant chose to drop it).
    confirmLeave() {
      if (!this.isDirty) {
        return true;
      }
      return window.confirm("You have unsaved changes. Leave this page without saving?");
    },

    onBeforeUnload(event) {
      if (this.isDirty) {
        event.preventDefault();
        event.returnValue = "";
      }
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    notify(type, message) {
      this.snackbar = type;
      this.message = message;
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    getPromoCodeDetail() {
      const promoCodeId = this.$route.params.id;
      this.isLoadDoneData = false;
      this.errors = {};
      this.showLoader();

      if (!promoCodeId) {
        SettingPromoCodeService.createNewPromoCode().then(
          (response) => {
            if (response.data.result.isSuccess) {
              const data = response.data.data;
              this.branches = data.branches;
              this.reportGroups = data.report_groups ?? [];
              this.promoCodeIdDummy = data.promo_code_id;
              this.schedulesAvailable = Array.isArray(data.schedules);
              this.timeUnits = data.time_unit;
              this.promo_code.apply_for_store = data.apply_for_store;
              this.markSaved();
              this.isLoadDoneData = true;
            } else {
              this.notify("danger", response.data.result.message);
            }
            this.hideLoader();
          },
          (error) => {
            this.notify("danger", error);
            this.hideLoader();
          }
        );
        return;
      }

      SettingPromoCodeService.getDataPromoCodeDetail(promoCodeId).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.promo_code = data.promo_code;
            this.promo_code.report_group_ids = this.promo_code.report_group_ids ?? [];
            this.promo_code.daily_limit = this.promo_code.daily_limit ?? "";
            this.savedDailyLimit = Number(this.promo_code.daily_limit) || null;
            this.savedTotalQuantity = Number(this.promo_code.total_quantity) || 0;
            this.timeUnits = data.time_unit;
            this.branches = data.branches;
            this.reportGroups = data.report_groups ?? [];
            this.schedulesAvailable = Array.isArray(data.schedules);
            this.schedules = data.schedules ?? [];
            this.schedulesEnabled = Number(data.schedules_enabled ?? 0);
            this.markSaved();
            this.isLoadDoneData = true;
            if (Number(this.promo_code.promo_type) === 2) {
              this.getList(1);
            }
          } else {
            this.notify("danger", response.data.result.message);
          }
          this.hideLoader();
        },
        (error) => {
          this.notify("danger", error);
          this.hideLoader();
        }
      );
    },

    savePromoCode() {
      if (this.saving || !this.processValidate()) {
        return;
      }

      const page = this.$route.query.page ?? 1;
      const isDate = this.expiryMode === "date";
      const isNew = !this.promo_code.id;
      const form = {
        ...this.promo_code,
        // The form owns one expiry; the other mode's values are not saved.
        fixed_date: isDate ? 1 : 0,
        expiry_after: isDate ? 0 : 1,
        expiry_date: isDate ? this.dateFormat(this.promo_code.expiry_date) : "",
        time_number: isDate ? "" : this.promo_code.time_number,
        // Sent as whole numbers ("10.0" passes the check above, the API's integer rule refuses it).
        total_quantity: positiveInt(this.promo_code.total_quantity),
        daily_limit: positiveInt(this.promo_code.daily_limit) ?? "",
      };

      this.saving = true;
      this.showLoader();
      SettingPromoCodeService.addOrUpdatePromoCode(form).then(
        (response) => {
          this.saving = false;
          this.hideLoader();
          if (!response.data.result.isSuccess) {
            this.notify("danger", response.data.result.message);
            return;
          }
          this.markSaved();
          const created = response.data.data.promo_code;
          if (isNew && created && created.id) {
            // Stay on the new promo: its usage schedule (and unique codes) can only be set once saved.
            this.notify("success", "Promo code created. You can now set its usage schedule.");
            this.$router.replace("/promo-code/" + created.id + "?page=" + page);
          } else {
            this.notify("success", "Save Promo Code Success");
            this.$router.push("/promo-codes/?page=" + page);
          }
        },
        (error) => {
          this.saving = false;
          this.hideLoader();
          this.notify("danger", error);
        }
      );
    },

    onSchedulesSaved(data) {
      this.schedules = data.schedules ?? [];
      this.schedulesEnabled = Number(data.schedules_enabled ?? 0);
      this.notify("success", "Usage schedule saved");
    },

    // Same rules as the API (PromoCodeDetailRequest), so the merchant sees them under each field.
    processValidate() {
      const promo = this.promo_code;
      const errors = {};

      if (!String(promo.promo_name ?? "").trim()) {
        errors.promo_name = "The field is required.";
      }

      const percentage = Number(promo.discount_value_percentage);
      const amount = Number(promo.discount_value_fixed_amount);
      if (promo.discount_type == 1) {
        if (promo.discount_value_percentage === "" || promo.discount_value_percentage == null) {
          errors.discount = "Please enter the percentage off.";
        } else if (!(percentage > 0) || percentage > 100) {
          errors.discount = "The percentage off must be more than 0 and at most 100.";
        }
      } else if (promo.discount_value_fixed_amount === "" || promo.discount_value_fixed_amount == null) {
        errors.discount = "Please enter the amount off.";
      } else if (!(amount > 0)) {
        errors.discount = "The amount off must be more than 0.";
      }

      if (promo.apply_scope == 2 && !(promo.report_group_ids ?? []).length) {
        errors.report_group_ids = "Please select at least one report group.";
      }

      if (promo.promo_type == 1 && !String(promo.promo_code ?? "").trim()) {
        errors.promo_code = "Please enter the promo code customers will type.";
      }

      if (this.expiryMode === "date") {
        if (!promo.expiry_date) {
          errors.expiry = "Please select the expiry date.";
        }
      } else if (!positiveInt(promo.time_number) || !promo.time_unit) {
        errors.expiry = "Please enter how long each code lasts after it is issued.";
      }

      const total = positiveInt(promo.total_quantity);
      if (!total) {
        errors.total_quantity = "The issue quantity must be a whole number of at least 1.";
      } else if (total < this.minQuantity.value) {
        errors.total_quantity = `The issue quantity cannot be lower than ${this.minQuantity.value} (${this.minQuantity.reason}).`;
      }

      if (promo.daily_limit !== "" && promo.daily_limit != null) {
        const daily = positiveInt(promo.daily_limit);
        if (!daily) {
          errors.daily_limit = "The daily limit must be a whole number of at least 1, or left empty for no limit.";
        } else if (total && daily > total) {
          errors.daily_limit = "The daily limit cannot be more than the issue quantity.";
        }
      }

      this.errors = errors;
      const isValid = Object.keys(errors).length === 0;
      if (!isValid) {
        scrollToFirstInvalid();
      }

      return isValid;
    },

    backPromoCodeList() {
      const page = this.$route.query.page;
      this.$router.push(page ? "/promo-codes?page=" + page : "/promo-codes");
    },

    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },

    onCodeSearch() {
      clearTimeout(this.codeSearchTimer);
      this.codeSearchTimer = setTimeout(() => this.getList(1), 500);
    },

    onCodeStatus(value) {
      this.codeStatus = value;
      this.getList(1);
    },

    // Also called by Pagination ($parent.getList).
    getList(page) {
      if (!this.promo_code.id) {
        return;
      }
      SettingPromoCodeService.getDataPromoCodeDistribution(this.promo_code.id, page, {
        status: this.codeStatus,
        search_code: this.codeSearch,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.promo_code_data = response.data.data.items;
            this.pagination = response.data.data;
            this.page = this.pagination.current_page;
          } else {
            this.notify("danger", response.data.result.message);
          }
        },
        (error) => {
          this.notify("danger", error);
        }
      );
    },
  },
};
</script>
<style scoped>
.promo-card {
  padding: 24px 28px 0;
}
.promo-head {
  padding-bottom: 16px;
}
.promo-id {
  padding: 2px 10px;
  border-radius: 10px;
  background: #e9ecef;
  color: #67748e;
  font-size: 13px;
  font-weight: 600;
}
.promo-summary {
  margin-top: 6px;
  color: #344767;
  font-size: 14px;
}
.promo-section {
  border-top: 1px solid #e9ecef;
  padding: 14px 0 6px;
}
.promo-section__title {
  margin-bottom: 4px;
  color: #7b809a;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.promo-row {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  gap: 4px 24px;
  padding: 8px 0;
  align-items: start;
}
.promo-label {
  margin: 0;
  padding-top: 8px;
  color: #133067;
  font-size: 14px;
  font-weight: 600;
}
.promo-field {
  max-width: 640px;
}
.promo-field--narrow {
  max-width: 320px;
}
.radio-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 0 28px;
  padding-top: 4px;
}
.radio-inline .form-check {
  padding-left: 0;
}
.promo-value {
  max-width: 320px;
  margin-top: 6px;
}
.promo-affix {
  padding: 0 6px;
  color: #67748e;
}
.promo-hint {
  margin-top: 4px;
  color: #7b809a;
  font-size: 12px;
}
.promo-period {
  max-width: 420px;
  margin-top: 6px;
}
.promo-period__number {
  flex: 0 0 110px;
}
/* The page-wide .multiselect rule below stretches every dropdown to 100%. */
.multiselect.promo-period__unit {
  flex: 0 0 160px;
  width: 160px !important;
  min-width: 0 !important;
}
.promo-usage {
  margin-top: 8px;
  color: #344767;
  font-size: 12px;
}
.promo-usage__bar {
  height: 6px;
  margin-bottom: 4px;
  border-radius: 3px;
  background: #e9ecef;
  overflow: hidden;
}
.promo-usage__bar span {
  display: block;
  height: 100%;
  background: #4caf50;
}
.promo-today {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 10px;
  border-radius: 10px;
  background: #e8f5e9;
  color: #2e7d32;
  font-size: 12px;
  font-weight: 600;
}
.promo-today--full {
  background: #fff3e0;
  color: #e65100;
}
.promo-actions {
  position: sticky;
  bottom: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin: 8px -28px 0;
  padding: 12px 28px;
  border-top: 1px solid #e9ecef;
  border-radius: 0 0 0.75rem 0.75rem;
  background: #fff;
}
.promo-actions__dirty {
  margin-right: auto;
  color: #fb8c00;
  font-size: 13px;
}
.save-btn {
  min-width: 160px;
}
.promo-codes-title {
  color: #133067;
}
.promo-chip {
  padding: 2px 10px;
  border-radius: 10px;
  background: #e9ecef;
  color: #67748e;
  font-size: 12px;
  font-weight: 600;
}
.promo-chip--used {
  background: #e8f5e9;
  color: #2e7d32;
}
.promo-chip--expired {
  background: #fdecea;
  color: #c62828;
}
.promo-code-cell {
  font-family: monospace;
}
input.nosubmit {
  border: none;
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
  font-size: 14px;
}
input.nosubmit:focus {
  outline: none;
  border-bottom: 2px solid #72959d;
}
@media (max-width: 767px) {
  .promo-card {
    padding: 16px 16px 0;
  }
  .promo-row {
    grid-template-columns: minmax(0, 1fr);
  }
  .promo-label {
    padding-top: 0;
  }
  .promo-actions {
    margin: 8px -16px 0;
    padding: 12px 16px;
  }
}
/* Usage schedule button, styled like StoreDetail's .price-schedule-btn. */
.promo-schedule-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  white-space: nowrap;
}
/* .btn-sm shrinks icons. */
.promo-schedule-btn .promo-schedule-btn__icon {
  font-size: 18px !important;
}
.promo-schedule-btn__state {
  padding: 2px 8px;
  border-radius: 10px;
  background: #e9ecef;
  color: #67748e;
  font-size: 11px;
  text-transform: none;
}
.promo-schedule-btn__state--on {
  background: #4caf50;
  color: #fff;
}
.promo-schedule-btn__state--ended {
  background: #fb8c00;
  color: #fff;
}
.text-back {
  color: black !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  font-family: "Roboto Slab", sans-serif !important;
}
.multiselect {
  min-width: 120px !important;
  width: 100% !important;
  display: block !important;
}
</style>
